'use strict';
var BuyPath = function(buyPath) {
    this.buyPath = buyPath;
};
BuyPath.prototype.build = function() {
    return this.buyPath;
};
module.exports = BuyPath;
